import { useEffect, useState } from "react";
import { Loader2, Users, Mail } from "lucide-react";
import api from "../lib/api";

export default function WaitlistAdminPanel() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/waitlist")
      .then((r) => setData(r.data))
      .catch(() => setData({ items: [], summary: [], total: 0 }))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="waitlist-admin-panel" className="bg-white border border-[#E8E6E1] rounded-xl p-6">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h2 className="font-heading font-semibold text-lg text-[#1C211F]">Add-on waitlist</h2>
          <p className="text-sm text-[#57605A] mt-1">
            People interested in the upcoming Nexari add-ons. Use this to prioritize what to build next.
          </p>
        </div>
        {data && (
          <span className="text-sm text-[#57605A] inline-flex items-center gap-1.5">
            <Users className="w-4 h-4" strokeWidth={1.5} />
            <strong className="text-[#1C211F]">{data.total}</strong> total signups
          </span>
        )}
      </div>

      {loading ? (
        <div className="flex items-center justify-center py-10">
          <Loader2 className="w-5 h-5 text-[#2E5C50] animate-spin" />
        </div>
      ) : (
        <>
          {data.summary.length > 0 && (
            <div className="mt-5 grid grid-cols-2 md:grid-cols-4 gap-3">
              {data.summary.map((s) => (
                <div key={s.addon_id} data-testid={`waitlist-count-${s.addon_id}`}
                     className="bg-[#F9F7F4] border border-[#E8E6E1] rounded-md p-3">
                  <p className="text-xs text-[#57605A] truncate" title={s.addon_name}>{s.addon_name}</p>
                  <p className="mt-1 text-xl font-light text-[#2E5C50]">{s.count}</p>
                </div>
              ))}
            </div>
          )}

          {data.items.length === 0 ? (
            <p data-testid="waitlist-empty" className="mt-6 text-sm text-[#57605A] text-center py-6">
              No waitlist signups yet — share <code className="bg-[#F0EDE8] px-1.5 py-0.5 rounded text-xs">nexarihealth.com/pricing</code> to start collecting interest.
            </p>
          ) : (
            <div className="mt-5 border-t border-[#E8E6E1] pt-4 max-h-80 overflow-y-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="text-left text-xs uppercase tracking-wider text-[#57605A]">
                    <th className="py-2">When</th>
                    <th>Add-on</th>
                    <th>Email</th>
                    <th>Org</th>
                  </tr>
                </thead>
                <tbody>
                  {data.items.map((w) => (
                    <tr key={w.id} data-testid={`waitlist-row-${w.id}`} className="border-t border-[#F0EDE8]">
                      <td className="py-2 text-xs text-[#57605A]">
                        {new Date(w.created_at).toLocaleDateString()}
                      </td>
                      <td className="text-xs text-[#1C211F]">{w.addon_name}</td>
                      <td>
                        <a href={`mailto:${w.email}`} className="text-xs text-[#2E5C50] hover:underline inline-flex items-center gap-1">
                          <Mail className="w-3 h-3" /> {w.email}
                        </a>
                      </td>
                      <td className="text-xs text-[#57605A]">{w.organization || w.name || "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </div>
  );
}
